import { endpoints } from '@/api';
import { queryClient } from '@/api/queryClient';
import { realtime } from '@/realtime';
import { useAuth } from '@/stores/auth';
import { serverClock } from './clock';

/** Sign out locally and on the server (best effort). */
export async function signOut(): Promise<void> {
  realtime.stop();
  try {
    await endpoints.logout();
  } catch {
    /* cookie may already be gone */
  }
  queryClient.clear();
  serverClock.reset();
  useAuth.getState().clear();
}
